import { render, staticRenderFns } from "./StandardButton.vue?vue&type=template&id=c861b6e6&scoped=true&"
import script from "./StandardButton.vue?vue&type=script&lang=js&"
export * from "./StandardButton.vue?vue&type=script&lang=js&"
import style0 from "./StandardButton.vue?vue&type=style&index=0&id=c861b6e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c861b6e6",
  null
  
)

export default component.exports